var _circle, _circle2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIc1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "url(#a9636548)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#c9636548)",
    d: "M0 0h12v12H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.14 3.24h1.712c.752 0 1.36.297 1.368 1.052v4.212a.29.29 0 0 1-.033.136.287.287 0 0 1-.172.139.277.277 0 0 1-.22-.028l-1.798-.9-1.8.9a.295.295 0 0 1-.136.036.282.282 0 0 1-.28-.283V4.292c0-.755.61-1.052 1.359-1.052zm-.188 2.114h2.09c.119 0 .216-.097.216-.219a.217.217 0 0 0-.217-.219H4.952a.217.217 0 0 0-.216.22c0 .121.097.218.216.218z",
    fill: "url(#a9636548)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9636548",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c9636548",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1080FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc1);
export default __webpack_public_path__ + "static/media/ic1.90aa19ec.svg";
export { ForwardRef as ReactComponent };